import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "p-3 h-100 w-100" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_entity_component = _resolveComponent("g-entity-component");
    const _component_portal_target = _resolveComponent("portal-target");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, {
        "show-header": false,
        "class-content": "content__no-marging content__no-overflow"
    }, {
        "modal-footer": _withCtx(() => [
            _createVNode(_component_portal_target, {
                name: '__footer_' + this.currentWindow.id,
                multiple: ""
            }, null, 8, ["name"])
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_g_entity_component, { window: _ctx.window }, null, 8, ["window"])
            ])
        ]),
        _: 1
    }));
}
